import apiClient from "./config";

const serviceCategoryService = {
  // Get all service categories
  getAllCategories: async () => {
    try {
      const response = await apiClient.get("/service-categories");
      return response.data.categories || [];
    } catch (error) {
      console.error(
        "Error in getAllCategories:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to fetch categories"
      );
    }
  },

  // Get category by ID
  getCategoryById: async (categoryId) => {
    try {
      const response = await apiClient.get(`/service-categories/${categoryId}`);
      return response.data.category;
    } catch (error) {
      console.error(
        "Error in getCategoryById:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to fetch category details"
      );
    }
  },

  // Create new category
  createCategory: async (categoryData) => {
    try {
      const response = await apiClient.post(
        "/service-categories",
        categoryData
      );
      return response.data.category;
    } catch (error) {
      console.error(
        "Error in createCategory:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to create category"
      );
    }
  },

  // Update category
  updateCategory: async (categoryId, categoryData) => {
    try {
      const response = await apiClient.put(
        `/service-categories/${categoryId}`,
        categoryData
      );
      return response.data.category;
    } catch (error) {
      console.error(
        "Error in updateCategory:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to update category"
      );
    }
  },

  // Delete category
  deleteCategory: async (categoryId) => {
    try {
      const response = await apiClient.delete(
        `/service-categories/${categoryId}`
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error in deleteCategory:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to delete category"
      );
    }
  },
};

export default serviceCategoryService;
